import * as Html from "../util/Html.ts";
import * as amplify from "../util/amplify.ts";
import * as modal from "../util/modal.ts";
import ApiServer from "../ApiServer.js";
import * as blackveil from "../lib/blackveil2.js";
import $ from "../$.js";

export {init,destroy}
Html.registerWidget('widget/activity-form',{init:init,destroy:destroy})

ApiServer["custom.wallpublish"] = function(form,success,error){
  if(form.giphy){
    form.tagline.value = (form.tagline.value + "\r\n\r\n" + form.giphy.value).trim();
  }
  ApiServer.wallpublish(form,success,error);
  cancel();
}
amplify.subscribe('newActivity',cancel)
var root;

function updateHtml(TPL){
  fixheight();
  var text = root.find('textarea').val();
  Html.setHtml(root,TPL,{});
  root.find('textarea').focus().val(text);
  if(!root.data('open')){
    //root.css('position','relative');
    root.css('z-index',11);
    blackveil.show(root).on('click',askcancel);
    root.data('open',true);
  }
  adjustheight();
}

Html.register({
  openPostCancel:cancel,
  openPostMessage:function(){
    import("../form/post-message.mustache").then(function(TPL){
      root.attr('data-fw-dyn-action',"custom.wallpublish")
      updateHtml(TPL);
    });
  },
  openPostPhoto:function(){
    import("../form/post-photo.mustache").then(function(TPL){
      root.attr('data-fw-dyn-action',"custom.wallpublishphoto")
      updateHtml(TPL);
    });
  },
  openPostCheckin:function(){
    import("../form/post-checkin.mustache").then(function(TPL){
      root.attr('data-fw-dyn-action',"custom.checkin")
      updateHtml(TPL);
    })
  },
  openGif:function(){
    Html.trigger(this.next(),"opendropdown");
  },
  openPostGif:function(){
    import("../form/post-message.mustache").then(function(TPL){
      root.attr('data-fw-dyn-action',"custom.wallpublish")
      updateHtml(TPL);
      setTimeout(function(){
        Html.trigger(root.find("*[data-fw-onclick='openGif']"),"openGif")
      },600);
    });
  }
});

function cancel(){
  import("../form/post-default.mustache").then(function(TPL){
    fixheight();
    root.data('open',false);
    root.data('changed',false);
    root.attr('data-fw-dyn-action',"custom.wallpublish")
    blackveil.hide(root).off('click',askcancel);
    Html.setHtml(root,TPL,{});
    adjustheight();
    setTimeout(function(){
      root.css('position','static')
    },600)
  })
}

async function askcancel(){
  var hasChanged = false;
  //for textarea
  if(root.find('textarea').val().trim().length>0){
    hasChanged = true;
  }
  //dropped image
  if(root.find('input[name=picture]').length>0){
    hasChanged = true;
  }
  if(root.find('input[name=placeId]').val()){
    hasChanged = true;
  }
  if(hasChanged){
    if(await modal.confirm({title:'discard.title',message:'discard.message',yes:'discard.yes',no:'discard.no'})){
      cancel();
    }
  }else{
    cancel();
  }
}

var timeout;
function adjustheight(){
  root.css('overflow-y','hidden');
  root.css('height',calcHeight()+'px');
  clearTimeout(timeout);
  timeout = setTimeout(function(){
    root.css('overflow-y','visible');
    root.css('height','auto');
  },800);
}
function fixheight(){
  root.css('height',calcHeight()+'px');
}
function calcHeight(){
  var h = 0;
  root.children().each(function(idx,o){h+=$(o).height()});
  h+=parseInt(root.css('padding-top'))+parseInt(root.css('padding-bottom'))
  return h;
}

function init(obj){
  root = obj;
  root.css('transition','height 0.6s ease');
  root.css('height',calcHeight()+'px');
  obj.attr('data-fw-form-amplify','newActivity');
  amplify.subscribe('newActivity',cancel);
  amplify.subscribe('resetNewActivity',cancel)
  
  obj.on('paste',function(event){
    if(obj.attr('data-fw-dyn-action')==="custom.wallpublish"){
      var items = event.originalEvent.clipboardData.items;
      var clipboardImages = [];
      for(var i=0;i<items.length;i++){
        var file = items[i].getAsFile();
        if(file){
          clipboardImages.push(file);
        }
      }
      if(clipboardImages.length){
        root.get(0).clipboardImages = clipboardImages;
        Html.trigger('openPostPhoto');
      }
    }
  })
  
}
function destroy(obj){
  var veil = blackveil.hide(root);
  if(veil){
    veil.off('click',askcancel);
  }
  amplify.unsubscribe('newActivity',cancel);
  amplify.unsubscribe('resetNewActivity',cancel)
  root =null;
}
